import { render } from "./ThePdfViewer.vue?vue&type=template&id=6eebc26c&scoped=true"
import script from "./ThePdfViewer.vue?vue&type=script&lang=js"
export * from "./ThePdfViewer.vue?vue&type=script&lang=js"

import "./ThePdfViewer.vue?vue&type=style&index=0&id=6eebc26c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eebc26c"]])

export default __exports__